/** 리퍼러 표시용 호스트 추출. 빈 값은 직접 유입으로 표기한다. */
export function extractHost(referer?: string | null): string {
  const value = referer?.trim()
  if (!value) {
    return '직접 유입'
  }

  try {
    const host = new URL(value).hostname.toLowerCase()
    return host.startsWith('www.') ? host.slice(4) : host
  } catch {
    return value
  }
}
